<template>
  <div class="productCodeApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:12px" v-if="setOrder.status < 4"></div>
    <div class="pwd" v-if="setOrder.status == 6 && setOrder.user_id == userData.id && setOrder.lock_pwd != null">您的开锁密码：{{setOrder.lock_pwd}}</div>
    <div style="height:65px" v-if="setOrder.status == 6 && setOrder.user_id == userData.id"></div>
    <div class="infoCon" v-if="setOrder.status >= 3">
      <h2>配送快递
        <font v-if="setOrder.status >= 4 && setOrder.status < 6">（{{setOrder.status == 4 ? '配送员:'+delivery.name : '联络员:'+end.name}}）</font>
        <a v-if="setOrder.status >= 4 && setOrder.status < 6" :href="'tel:'+(setOrder.status == 4 ? delivery.phone : end.phone)"><i class="el-icon-phone-outline"></i> 打电话</a>
      </h2>
      <el-timeline>
        <el-timeline-item timestamp="配送起点" placement="top" icon="el-icon-success" type="primary" color="#fff" size="large">
          <div class="initial">
            <h4>{{setOrder.startTitle}}</h4>
          </div>
        </el-timeline-item>
        <el-timeline-item :timestamp="setOrder.status == 4 ? '配送中' : setOrder.status == 5 ? '已送达' :setOrder.status == 6 ? '已签收' :'未接单'" placement="top" :icon="setOrder.status >= 5 ? 'el-icon-success' : 'el-icon-more'" type="primary" :color="setOrder.status >= 5 ? '#fff' : '#F2995F'" size="large">
          <div class="initial">
            <h4 style="margin-bottom:8px">{{setOrder.address}}</h4>
            <p><i class="el-icon-user-solid"></i>{{setOrder.name}} {{setOrder.phone}} <font style="background: #fff;font-size:10px;padding:3px 4px;vertical-align:middle;color:#E34D59;border-radius:4px">号码保护中</font></p>
          </div>

        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="cont">
      <div class="info">
        <h2 class="title">
          <div>
            <el-image style="width:25px;height:25px; border-radius:50%;vertical-align: middle;margin-right:5px" :src="baseUrl+setOrder.logo" fit="cover"></el-image>{{setOrder.startTitle}}
          <span :style="setOrder.status == 2 ? 'border-color: #0052D9;color:#0052D9' : setOrder.status == 3 ? 'border-color: #ED7B2F;color:#ED7B2F' : setOrder.status == 4 ? 'border-color: #E34D59;color: #E34D59;' : setOrder.status == 5 ? 'border-color: #5326DB;color: #5326DB;' : setOrder.status == 6 ? 'border-color: #00A870;color: #00A870;' : 'border:none'">{{setOrder.status == 2 ? '已支付\n未存放' : setOrder.status == 3 ? '已存放\n待配送' : setOrder.status == 4 ? '配送中\n待入库' : setOrder.status == 5 ? '已入库\n待领取' : setOrder.status == 6 ? '已完成' : ''}}</span>
          </div>
          
        </h2>
        <div class="code" v-if="setOrder.status == 5 && setOrder.user_id == userData.id">
          <p class="a1">核销订单二维码</p>
          <div class="expl">
            <div class="qrcode" id="qrcode" ref="qrCodeUrl"></div>
          </div>
          <p class="a2">请出示扫码，领取物品</p>
        </div>

        <div class="goods">
          <div class="left">
            <el-image style="width:100%;height:50px; border-radius:5px;" :src="baseUrl+setOrder.image" fit="cover"></el-image>
          </div>
          <div class="right">
            <p>{{setOrder.title}}</p>
            <div class="num">购买数量：{{setOrder.num}}件</div>
            <div class="price">
              <i>￥</i><b>{{setOrder.price}}</b>
            </div>
          </div>
        </div>
        <h2>
          <p>营业时间：周一至周日 6:00 ~ 23:00</p>
          <p>以上信息仅供参考，具体以实际公示信息为准。</p>
        </h2>
        <h2 class="box">取件时间：{{setOrder.deliver_time}}</h2>
        <h2 class="box">订单编号：{{setOrder.number}}</h2>
        <h2 class="box">支付时间：{{setOrder.paytime}}<font style="color:#E34D59">（{{setOrder.pay_type == 1 ? '微信支付' : (setOrder.pay_type == 2 ? '组合支付' : '余额支付')}} {{setOrder.price}}元）</font></h2>
        <h2 class="box">备注信息：{{setOrder.mark}}</h2>
        <h2 class="box" v-if="setOrder.status == 2 && setOrder.user_id == userData.id">拍照留存：
          <span @click="getQquey">上传图片<i class="el-icon-arrow-right"></i></span>
          <el-image v-if="image!='' && setOrder.status == 2" style="width:100%;height:240px; border-radius:5px;" :src="baseUrl+image" fit="cover"></el-image>
        </h2>
        <h2 class="box" v-if="setOrder.status >= 3">存入图片信息：<el-image style="width:100%;height:240px; border-radius:5px;" :src="baseUrl+setOrder.cimg" fit="cover"></el-image></h2>

        <h2 class="box" v-if="setOrder.status == 4 && setOrder.is_delivery > 0 && setOrder.lockTotal > 0">存入密码：
          <span @click="getLock">{{setLockPwd == '' ? '获取密码' : '开锁密码：'+setLockPwd}}<i class="el-icon-arrow-right"></i></span>
        </h2>
        <h2 class="box" v-if="setOrder.status == 4 && setOrder.is_delivery > 0">入库图片上传：
          <span @click="getQquey">上传图片<i class="el-icon-arrow-right"></i></span>
          <el-image v-if="image!='' && setOrder.status == 4 && setOrder.is_delivery > 0" style="width:100%;height:240px; border-radius:5px;" :src="baseUrl+image" fit="cover"></el-image>
        </h2>

        <h2 class="box" v-if="setOrder.status >= 5">送达图片信息：<el-image style="width:100%;height:240px; border-radius:5px;" :src="baseUrl+setOrder.deliver_img" fit="cover"></el-image></h2>
      </div>
    </div>
    <div style="height:80px"></div>
    <div class="btn" @click="save(0)" v-if="setOrder.status == 2 && setOrder.user_id == userData.id">
      <a>存入指定位置</a>
    </div>
    <div class="btn" @click="save(1)" v-if="setOrder.status == 3 && setOrder.is_delivery == 1">
      <a>立即接单，发起配送</a>
    </div>
    <div class="btn" @click="save(2)" v-if="setOrder.status == 4 && setOrder.is_delivery > 0">
      <a>确认送达目的地</a>
    </div>
    <div class="btn" @click="save(3)" v-if="setOrder.status == 5 && end.user_id == userData.id && setOrder.lockTotal <= 0">
      <a>确认用户领取</a>
    </div>
    <div class="btn" @click="save(4)" v-if="setOrder.status == 5 && setOrder.user_id == userData.id && setOrder.lock_pwd != null">
      <a>确认领取，并且获取开锁密码</a>
    </div>

    <el-drawer title="请选择您需要存入的密码锁" :visible.sync="drawer" size="60%" :direction="direction" :withHeader="true" :show-close="true" :wrapperClosable="false">
      <ul>
        <li v-for="(item,i) in setLock">
          <div class="left">
            <h2>编号：{{item.number}}</h2>
            <p>名称：{{item.title}}</p>
          </div>
          <a @click="lockPwd(item.lock_id)">获取开锁密码</a>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        drawer:false,
        direction: 'btt',
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        positionFlag:false,
        setOrder:[],
        delivery:[],
        end:[],
        id:'',
        image:'',
        setLock:[],
        setLockPwd:'',
        lockId:''
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.id = this.$route.query.id;
    },
    mounted() {
      this.beforeMount();
      this.getOrder(this.$route.query.id);
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getCode:function(id){
        document.getElementById('qrcode').innerHTML = ''
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: 'http://user.4008005216.com/main/lcode?id='+id, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      save:function(inx){
        var that = this;
        var id = this.id;
        var txt = inx == 0 ? '是否立即存入？' : inx == 1 ? '是否立即接下订单？' : inx == 2 ? '确认送达订单' : inx ==  3 ? '确认出货订单' : '确认领取，并且获取开锁密码'
        var u = JSON.parse(localStorage.getItem('userjwt'));
        if(inx == 0 && that.image == ''){
          that.$alert('请先拍照上传物品，确保物品完整性','提示');
          return false;
        }
        if(inx == 2 && that.setLockPwd == '' && that.setOrder.lockTotal > 0){
          that.$alert('请先获取锁密码，并且把行李箱锁上，拍照上传确认送达','提示');
          return false;
        }
        if(inx == 2 && that.image == ''){
          that.$alert('请先拍照上传物品，确保物品完整送达','提示');
          return false;
        }
        that.$confirm(txt,'提示').then(_ => {
          that.fullscreenLoading = true;
          $.ajax({
            type:'post',
            url:that.$host+'home/luggage/save',
            data:{
              id:id,
              user_id:u.id,
              img:that.image,
              lockId:that.lockId
            },
            dataType:'json',
            success:function(data){
              if(data.status == 200){
                that.getOrder(id);
              }else{
                that.$alert(data.message,'提示')
              }
              that.fullscreenLoading = false;
            }
          })
        }).catch(_ => {});
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s)
                          }
                      });
                  }
                })
              }
            });
            
          });
        }).catch(err=>{
          that.fullscreenLoading = false;
        });
      },
      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/product/upload',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.image = msg.data;
            }else{
              that.$alert('上传失败','提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      tabCode:function(id){
        this.id = id;
        this.getOrder(id)
      },
      getOrder:function(id){
        var that = this;
        var u = JSON.parse(localStorage.getItem('userjwt'));
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/orderDetail',
          data:{
            id:id,
            user_id:u.id
          },
          dataType:'json',
          success:function(data){
            that.setOrder = data.data;
            that.delivery = data.data.delivery;
            that.end = data.data.end;
            if(data.data.status == 5){
              setTimeout(function(){
                that.getCode(id);
              },100);
            }
            that.fullscreenLoading = false;
          }
        })
      },
      
      getLock:function(){
        var that = this;
        $.ajax({
          url:this.$host+'home/luggage/lock',
          method: 'post',
          data:{
            end_id:that.setOrder.end_id
          },
          success:function(data){
            if(data.status == 200){
              that.drawer = true;
              that.setLock = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      lockPwd:function(lockId){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          url:this.$host+'home/luggage/getLockpwd',
          method: 'post',
          data:{
            lockId:lockId
          },
          success:function(data){
            if(data.status == 200){
              that.drawer = false;
              that.setLockPwd = data.data.keyboardPwd;
              that.lockId = lockId;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .productCodeApp{
    background:#F1F2F5;
    width:100%
  }
  .productCodeApp .infoCon{
    background:#fff;
    margin-bottom:12px
  }
  .productCodeApp .infoCon h2{
    width:94%;
    margin:0 auto;
    font-size:16px;
    padding:15px 0
  }
  .productCodeApp .infoCon h2 font{
    font-weight:normal;
    font-size:14px;
    color:#555;
  }
  .productCodeApp .infoCon h2 a{
    float:right;
    font-weight:normal;
    font-size:14px;
    color: #0052D9;
    text-decoration: none;
  }
  .productCodeApp .infoCon .el-timeline{
    width:92%;
    margin:0 auto;
  }
  .productCodeApp .infoCon .el-timeline .el-timeline-item__node{
    background:#fff;
    width:15px;
    height:15px;
    left:-3px
  }
  .productCodeApp .infoCon .el-timeline .el-timeline-item__node .el-icon-success{
    font-size:16px;
    color:#00A870;
  }
  .productCodeApp .infoCon .el-timeline .el-timeline-item__node .el-icon-error{
    font-size:16px;
    color:#E34D59;
  }
  .productCodeApp .infoCon .el-timeline .el-timeline-item__tail{
    border-color:#ccc;
    border-width:1px
  }
  .productCodeApp .infoCon .el-timeline .el-timeline-item__timestamp{
    font-size:14px;
    color:#3C485C;
  }
  .productCodeApp .infoCon .el-timeline .initial{
    padding:10px;
    background:#F1F2F5;
    border-radius:5px;
    position: relative;
  }
  .productCodeApp .infoCon .el-timeline .initial:last-child{
    margin-bottom:0;
    border-bottom:none
  }
  .productCodeApp .infoCon .el-timeline .initial h4{
    color:#000;
    font-size:15px;
  }
  .productCodeApp .cont{
    width:96%;
    display:block;
    margin:0 auto;
    z-index:99;
  }
  .productCodeApp .cont .tab{
    background: #FDECEE;
    border-radius: 12px 12px 0 0;
    padding:10px 0
  }
  .productCodeApp .cont .tab a{
    font-size:12px;
    background: #fff;
    float:left;
    height: 30px;
    width: 70px;
    margin-left:10px;
    border-radius: 3px 3px 3px 3px;
    text-align:center;
    line-height: 30px;
    color: #3C485C;
    margin-bottom:10px
  }
  .productCodeApp .cont .tab a.curt{
    color: #0059D6;
  }
  .productCodeApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius: 6px;
  }
  .productCodeApp .info .goDetail{
    position:absolute;
    right:3%;
    top:5%;
    font-size:14px;
    color:#666
  }
  .productCodeApp .info h2{
    font-size:15px;
    padding:10px 0;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .productCodeApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:15px 0
  }
  .productCodeApp .info h2.box span{
    float:right;
    color:#666
  }
  .productCodeApp .info h2.box img{
    display:block;
    width:100%;
    margin-top:8px
  }
  .productCodeApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .productCodeApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 2px 0
  }
  .productCodeApp .info h2.title div{
    margin-bottom:6px
  }
  .productCodeApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
    float:right
  }
  .productCodeApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .productCodeApp .info h2 a{
    color:#2F78FF;
    text-decoration: none;
  }
  .productCodeApp .info .code .expl{
    position:relative;
    width:170px;
    height:170px;
    margin:0 auto;
  }
  .productCodeApp .info .code img{
    display:block;
    margin:0 auto;
    width:170px;
    height:170px;
  }
  .productCodeApp .info .code .expl b{
    position:absolute;
    width:170px;
    height:170px;
    background:rgba(255,255,255,0.9);
    top:0;
    left:0;
    text-align:center;
    line-height:170px;
    font-weight:400;
    color:#f00
  }
  .productCodeApp .info .code p.a1{
    text-align:center;
    font-size:18px;
    padding:20px 0 10px 0;
    font-weight:bold
  }
  .productCodeApp .info .code p.a2{
    text-align:center;
    color:#666;
    font-size:14px;
    padding:10px 0
  }

  .productCodeApp .goods:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .productCodeApp .goods{
    background:#f5f5f5;
    width:94%;
    margin:0 auto 1px auto;
  }
  .productCodeApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:2% 2% 2% 2%;
  }
  .productCodeApp .goods .right{
    float:left;
    margin-top:3%;
    width:77%;
    position: relative;
  }
  .productCodeApp .goods .right p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .productCodeApp .goods .right .num{
    font-size: 13px;
    color: #999999;
    padding-top:6px;
  }
  .productCodeApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right:0;
    text-align:right
  }
  .productCodeApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .productCodeApp .goods .right .price b{
    color: #f00;
    font-size:16px;
    font-weight:600;
  }

  .productCodeApp .goods .right .price i{
    color: #f00;
    font-size:13px;
    font-style:normal
  }
  
  .productCodeApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }

  .productCodeApp .btn{
    bottom:0;
    position:fixed;
    width:100%;
    background:#fff;
    height:70px;
    border-top:solid 1px #F1F2F5;
  }

  .productCodeApp .btn a{
    width:80%;
    margin:8px auto 0 auto;
    height:45px;
    background:#0059D6;
    text-align:center;
    line-height:45px;
    border-radius: 8px;
    color: #FFFFFF;
    display:block;
  }
  .productCodeApp .el-drawer__body li{
    width:94%;
    margin: 0 auto;
    background:#F1F2F5;
    margin-bottom:12px;
    border-radius: 8px;
  }
  .productCodeApp .el-drawer__body li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .productCodeApp .el-drawer__body li .left{
    float:left;
    width:60%;
    padding:3%
  }
  .productCodeApp .el-drawer__body li .left h2{
    font-size:18px;
    color:#0052D9;
  }
  .productCodeApp .el-drawer__body li .left p{
    font-size:14px;
    color:#666;
    padding-top:10px
  }
  .productCodeApp .el-drawer__body li a{
    width:100px;
    float:right;
    height:40px;
    background:#0052D9;
    color:#fff;
    border-radius: 8px;
    text-align:center;
    line-height:40px;
    margin:5% 3% 0 0;
    font-size:14px;
  }
  .productCodeApp .pwd{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    z-index:99;
    background:#fff;
    color:green;
    font-size:18px;
    text-align:center;
    padding:15px 0
  }
</style>